import type Phaser from 'phaser';
import { dailyLawn } from '../../gen/modes';
import type { GhostResponse } from '../../meta/online/schema';
import { todayKey } from '../records';
import type { LevelSceneData } from './LevelScene';
import { wipeTo } from './WipeScene';

/** Today's Daily, with the leader's run alongside as a ghost (CLUB > BOARDS and VERSUS). */
export function raceDailyLeader(scene: Phaser.Scene, ghost: GhostResponse): void {
  const date = todayKey();
  const daily = dailyLawn(date);
  const data: LevelSceneData = {
    level: daily.def,
    mowerId: daily.loaner,
    daily: date,
    ghost: { run: ghost.run, name: ghost.name, ticks: ghost.value },
  };
  wipeTo(scene, 'Level', data);
}
